import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Cards from './components/Cards';
import Ranking from './components/Ranking';
import Topics from './components/Topics';
import IndexSection from './components/IndexSection';
import Carousel from './components/Carousel';
import Updates from './components/Updates';
import Media from './components/Media';
import Faq from './components/Faq';
import About from './components/About';
import Comments from './components/Comments';
import AppSection from './components/AppSection';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Features />
        <Cards />
        <Ranking />
        <Topics />
        <IndexSection />
        <Carousel />
        <Updates />
        <Media />
        <Faq />
        <About />
        <Comments />
        <AppSection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}